import DynamicPieChart from './realmComponents/DynamicPieChart.js'

const renderByDisplayHint = (value, meta, metricKey) => {
        if (value === null || value === undefined) {
            return <span className="ts-null">—</span>;
        }
        const hint = meta?.display_hint || 'default';
        if (hint === 'tabledata' && value?.headers && value?.rows) {
            return (
                <table className="ts-table">
                    <thead>
                        <tr>
                            {value.headers.map((h, i) => (
                                <th key={i} style={{ fontSize: '10px' }}>{h}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {value.rows.map((row, rIdx) => (
                            <tr key={rIdx}>
                                {row.map((cell, cIdx) => (
                                    <td key={cIdx} style={{ fontSize: '10px' }}>{cell ?? '—'}</td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            );
        }
        if (hint === 'keypair_list' && typeof value === 'object') {
            return (
                <ul className="ts-keypair-list">
                    {Object.entries(value).map(([k, v]) => (
                        <li key={k}>
                            <strong
                                style={{
                                    fontSize: '10px',
                                    color: '#073029',
                                    display: 'block',
                                    marginBottom: '2px',
                                }}>{k}</strong>
                            <p style={{
                                textAlign: 'right',
                                margin: '0px',
                                fontSize: '10px',
                            }}>{v ?? '—'}</p>
                        </li>
                    ))}
                </ul>
            );
        }
        if (hint.startsWith('quantifiable')) {
            const [, unit] = hint.split(':');

            return (
                <div className="ts-quant">
                    <span className="ts-quant-value">
                        {typeof value === 'number'
                            ? value.toLocaleString()
                            : value}
                    </span>
                    {unit && <span className="ts-quant-unit">{unit}</span>}
                </div>
            );
        }
        if (hint.startsWith("chartdata_pie") && typeof value === "object") {
            const [, unit] = hint.split(":");

            return (
                <DynamicPieChart
                    value={value}
                    unit={unit}
                    height={160}
                />
            );
        }
    };

    export default renderByDisplayHint;